<template>
  <!-- <slide from="bottom" :show="successShow" height="100%"> -->
  <b-dialog :m-show="successShow">
    <div class="beast-login-warp register">
      <img v-if="showClose"  class="close" @click="close" src="./assets/close.png">
      <div class="login-head">
        <p class="r-success-title">注册成功</p>
        <p class="r-success-tips">你获得了BEAST 野兽派的居民证！</p>
      </div>

      <div class="login-main">
        <div class="forget-tips">
          <img class="passport" src="./assets/passport.png" height="752" width="576" alt="">
        </div>
      </div>
    </div>
  </b-dialog>

</template>

<script>
import Slide from '@/components/slide'
import BDialog from '@/components/dialog/login-dialog.vue'

export default {
  components:{
    Slide,
    BDialog
  },
  data (){
    return {
    }
  },
  props: {
    showClose: {
      default: true
    },
    successShow: {
      default: false
    }
  },
  methods: {
    close: function (){
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="stylus">
@import './index.styl'
.r-success-title
  font-size rem(25)
  color #282828
  padding-bottom rem(20)
.r-success-tips
  font-size rem(16)
  line-height rem(24)
.passport
  height rem(752/2)
  width rem(576/2)
  margin rem(25) auto
</style>



// WEBPACK FOOTER //
// register-success.vue?99a2084a